import { NthDayDropdown, NthWeekDropdown, NthMonthDropdown } from '../molecules/recurrence-dropdowns';
import { GetRuleRecurrenceFormFieldProps } from '../types'; // TODO: Refactor

type Props = {
  getFieldProps: GetRuleRecurrenceFormFieldProps; // TODO: Refactor
};

export const RepeatFrequencyDropdown = ({ getFieldProps }: Props) => {
  const repeatFrequencyType = getFieldProps('repeatFrequencyType').value;
  const repeatFrequencyFieldProps = getFieldProps('repeatFrequency');

  if (repeatFrequencyType === 'days') {
    return <NthDayDropdown {...repeatFrequencyFieldProps} />;
  }

  if (repeatFrequencyType === 'weeks') {
    return <NthWeekDropdown {...repeatFrequencyFieldProps} />;
  }

  if (repeatFrequencyType === 'months') {
    return <NthMonthDropdown {...repeatFrequencyFieldProps} />;
  }

  return null;
};
